<template>
  <b-field
    :label="label"
    :message="userInfo.message"
    :type="userInfo.type"
    :class="{ 'obligatoire': obligatoire }">
    <b-autocomplete
      @select="setUser"
      @typing="getUser"
      :data="userList"
      :value="userName"
      :field="field"
      :placeholder="placeholder"
      :disabled="disabled"
      :open-on-focus="true"
      :class="{ 'autocompleteRemoveIconRight': !userInfo.actif }"
      icon="magnify">
      <template slot="empty">
        {{$t('general.autocomplete.noRslt')}}
      </template>
    </b-autocomplete>
  </b-field>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import getValueByPath from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { get } from '@/api/utilisateur/index';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'user-selected',
  props: {
    value: {
      type: Number,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    obligatoire: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    critere: {
      type: Function,
      default: () => true,
    },
    field: {
      type: String,
      default: 'decorator.nomPrenom',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      userFiltered: [],
      userName: '',
      user: null,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    userId: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    users() {
      return cloneDeep(this.parametre(PARAMETRES_KEYS.utilisateur))
        .sort((a, b) => this.getValue(a).localeCompare(this.getValue(b)));
    },
    userActifFilter() {
      return this.users
        .filter(u => u.actif && this.critere(u));
    },
    userList() {
      return this.userFiltered
        .filter((u) => u.id !== this.userId);
    },
    userInfo() {
      if (!this.user) {
        return {
          message: '',
          type: '',
          userName: '',
          actif: true,
        };
      }
      const { actif, domaine } = this.user;
      let message = '';

      if (!actif) {
        message = this.$t('utilisateur.warning.utilisateurArchive');
      } else if (domaine) {
        message = this.$t('utilisateur.warning.utilisateurDomaine');
      }
      return {
        message,
        type: (!actif || domaine) ? 'is-warning' : '',
        userName: this.getValue(this.user),
        actif,
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getValue(obj) {
      return getValueByPath(obj, this.field);
    },
    getUser(text) {
      this.userFiltered = this.userActifFilter.filter((u) => {
        return this.getValue(u).toLowerCase().includes(text.toLowerCase());
      });
      if (!this.userFiltered.some((u) => this.getValue(u) === text)) {
        this.userId = null;
      }
    },
    setUser(data) {
      if (!data) return;
      this.userId = data.id;
      this.user = data;
      this.userName = this.getValue(data);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.userId) {
        const result = (await get(this.userId)).data.result;
        result.decorator = {
          nomPrenom: nomPrenomGetter(result),
        };
        this.user = cloneDeep(result);
      }
      await this.loadParametreUtilisateur();
      this.userFiltered = this.userActifFilter;
      this.userName = this.userInfo.userName;
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
